export class ChangePassword {
    public currentPassword: string;
    public newPassword: string;
}
